import ChartMixin from "@/components/Charts/mixins/bar-chart";

export default {
	name: "DriversReportDistanceChart",

	mixins: [ ChartMixin ],

	props: {
		item: Object,
		items: Array
	},

	data: () => ( {
		averageObjectValuePath: "stats.trips.distance",
		title: "Miles Driven",
		yAxisLabel: "Distance (Miles)"
	} ),

	computed: {
		barData() {
			if ( this.item ) {
				return [
					this.item.stats.trips.distance,
					this.averageValue
				];
			}

			return this.items.map( item => item.stats.trips.distance );
		},

		labels() {
			if ( this.item ) {
				return [
					this.item.driver.user.name.split( " " ),
					[ "All drivers", "average" ]
				];
			}

			return this.items.map( item => item.driver.user.name.split( " " ) );
		}
	}
};

